import { useCallback } from "react";
import useUploadyContext from "./useUploadyContext";
const useAbortItem = () => {
  const context = useUploadyContext();
  return useCallback(id => context.abort(id), [context]);
};
export default useAbortItem;